export default {
      id: "oc-incloudsphere-usage",
      viewBox: "0 0 463 378",
      url: __webpack_public_path__ + "sprite.svg#oc-incloudsphere",
      toString: function () {
        return this.url;
      }
    }